import script from "./TableForBulk.vue?vue&type=script&setup=true&lang=js"
export * from "./TableForBulk.vue?vue&type=script&setup=true&lang=js"

import "./TableForBulk.vue?vue&type=style&index=0&id=51a5b0c0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51a5b0c0"]])

export default __exports__